// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__Qnmfi","description":"MealItem_description__x8AFJ","price":"MealItem_price__n7z3s"};